/* unplugin-vue-components disabled */import { render } from "./MyDivider.vue?vue&type=template&id=611aca08&scoped=true"
import script from "./MyDivider.vue?vue&type=script&lang=js"
export * from "./MyDivider.vue?vue&type=script&lang=js"

import "./MyDivider.vue?vue&type=style&index=0&id=611aca08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-611aca08"]])

export default __exports__